module.exports = __webpack_public_path__ + "img/SX.8d3d0e5d.svg";